'use strict'

/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import {browserPC} from './screen'
import store from '../store'
import {userApi} from "./api";

axios.defaults.withCredentials = true

// 环境的切换
axios.defaults.baseURL = process.env.BASE_URL

// 请求超时时间
axios.defaults.timeout = 100000

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 禁止请求缓存
    if (/get/i.test(config.method)) { // 判断get请求
      config.params = config.params || {}
      config.params.t = Date.parse(new Date()) / 1000 // 添加时间戳
    }
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    store.state.loading = false
    if (response.status === 200) {
      let code = response.data.code
      let notPass = code <= 1000 && code > 0
      if (notPass) {
        alertMessage(response.data.message, code)
      } else {
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    store.state.loading = false
    let response = error.response
    let status = response.status
    if (status) {
      switch (status) {
        case 401: {
          if (response.data) {
            alertMessage(response.data.message, response.data.code)
          } else {
            alertMessage('非法用户，即将退出登录', 401)
          }
          setTimeout(function () {
            userApi.logout()
          }, 3000)
          break
        }
        case 403: {
          jumpLogin()
          break
        }
        case 504:
        case 404:
          alertMessage('网络请求不存在!')
          break
        case 500: {
          if (response.data) {
            let code = response.data.code
            let notPass = code <= 1000 && code > 0
            if (notPass) {
              if (code === 403) {
                jumpLogin()
              } else {
                alertMessage(response.data.message, code)
              }
            } else {
              return Promise.resolve(response)
            }
          } else {
            alertMessage(response.message, status)
          }
          break
        }
        default: {
          unknownMessage(status)
        }
      }
    } else {
      unknownMessage('error')
    }
  }
)

axios.jsonp = (url, data) => {
  if (!url) {
    alertMessage('Axios.JSONP 至少需要一个url参数!')
    return
  }
  const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
  const JSONP = document.createElement('script')
  JSONP.setAttribute('type', 'text/javascript')
  const headEle = document.getElementsByTagName('head')[0]
  let ret = ''
  if (data) {
    if (typeof data === 'string') {
      ret = '&' + data
    } else if (typeof data === 'object') {
      for (let key in data) {
        ret += '&' + key + '=' + encodeURIComponent(data[key])
      }
    }
    ret += '&_time=' + Date.now()
  }
  JSONP.src = `${url}?callback=${callback}${ret}`
  return new Promise((resolve) => {
    window[callback] = r => {
      resolve(r)
      headEle.removeChild(JSONP)
      delete window[callback]
    }
    headEle.appendChild(JSONP)
  })
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const getRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const postRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params)).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const postJsonRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const uploadRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const putRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const putJsonRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export const deleteRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      params: params,
      method: 'delete',
      url: `${url}`
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const patchRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      params: params,
      method: 'patch',
      url: `${url}`
    }).then(res => { resolve(res.data) }).catch(err => { reject(err.data) })
  })
}

export const jsonpRequest = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.jsonp(url, params).then(res => { resolve(res) }).catch(err => { reject(err) })
  })
}

/* eslint-disable */
export const rawRequest = function icAjax (opt) {
  opt = opt || {}
  opt.method = opt.method.toUpperCase() || 'POST'
  opt.url = opt.url || ''
  if (opt.async !== false) {
    opt.async = true
  }
  opt.data = opt.data || null
  opt.success = opt.success || function () {
  }
  var xmlHttp = null
  if (XMLHttpRequest) {
    xmlHttp = new XMLHttpRequest()
  } else {
    xmlHttp = new ActiveXObject('Microsoft.XMLHTTP')
  }
  var params = []
  if (opt.data) {
    for (var key in opt.data) {
      params.push(key + '=' + opt.data[key])
    }
  }
  xmlHttp.onreadystatechange = function () {
    let state = xmlHttp.readyState
    if (state === 4) {
      let code = xmlHttp.status
      if (code === 403) {
        jumpLogin()
      } else if (code === 200) {
        try {
          let data = JSON.parse(xmlHttp.responseText)
          opt.success(data)
        }
        catch (e) {
          alertMessage(e.message, code)
        }
      } else {
        alertMessage('同步请求错误', code)
      }
    } else {
      console.log('xmlHttp.readyState = ' +  state)
    }
  }
  // encodeURIComponent() url部分编码
  var postData = params.join('&')
  if (opt.method.toUpperCase() === 'POST') {
    xmlHttp.open(opt.method, opt.url, opt.async)
    xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
    xmlHttp.send(postData)
  } else if (opt.method.toUpperCase() === 'GET') {
    var url =  opt.url
    if (params.length > 0) {
      url = url + '?' + postData
    }
    xmlHttp.open(opt.method, url, opt.async)
    xmlHttp.send()
  }
}

function alertMessage (msg, code) {
  if (msg && msg.length > 0) {
    if (browserPC()) {
      Message.error({message: msg})
    } else {
      toast(msg) // mobile
    }
  } else {
    unknownMessage(code)
  }
}

function unknownMessage (code) {
  let msg =  code === 502 ? '站点服务重启中...' : code + ' : 未知错误'
  alertMessage(msg)
}

export const jumpLogin = function () {
   // 处理来自试题库定制域名详情页的链接域名不是e课堂域名的情况
   if (location.href.indexOf(process.env.VUE_APP_URL_STK) !== -1) {
    const url = location.href.replace(location.origin, process.env.VUE_APP_SITE)
    window.open(url, '_self')
    return;
  }
  if (!localStorage.getItem('jump-url-after-login') && location.hash !== '#/') {
    localStorage.setItem('jump-url-after-login', location.href)
  }
  const url = location.origin + '/login.html'
  window.open(url, '_self')
}

